<template>
		<div class="details" :style="listHeight">
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh" v-if="list.length != 0">
				<van-list
				  v-model="loading"
				  :finished="finished"
				  finished-text="没有更多了"
				  @load="onLoad"
				>
				  <van-cell v-for="(item, index) in list" :key="index">
				  	<van-col span="24" class="details_">
			        <div class="details_left">
			            <p class="title_1">{{item.typeName}}</p>
			            <p class="time_2">{{item.createTime}}</p>
			        </div>
			        <div class="details_right" :style="colorstyle" v-if="paramStyle == 1">
			            <span class="monts"><span v-if="listStyle == 'profit'">+</span>{{item.credits[0]}}.</span><span class="monts_">{{item.credits[1]}}</span>
			        </div>
			        <div class="details_right" :style="colorstyle" v-if="paramStyle == 2">
			            <span class="monts"><span v-if="listStyle == 'profit'">+</span>{{item.coin[0]}}.</span><span class="monts_">{{item.coin[1]}}</span>
			        </div>
			    	</van-col>
				  </van-cell>
				</van-list>
			</van-pull-refresh>
			
			<van-row class="empty" v-if="list.length == 0 && !hasList">
				<van-col class="emptyMsg" span="24">
					<img src="../../assets/myInvest/empty.png"/>
					<p class="tip">暂无相关记录</p>
				</van-col>
			</van-row>
			
			<div class="loading" v-if="list.length <= 0 && hasList">
		    	<img src="../../assets/common/loading.gif"/>
		    </div>
		    
		</div>
</template>
<script>
export default {
//	param=“a,b”//a=1积分 a=2红包；  b=1收益（income）b=2支出（expenses）；  
	props:{
		param: {
			type: String,
			detault: '0'
		}
	},
	data() {
	    return {
			list: [],
	      	loading: false,
	      	finished: false,
	      	isLoading: false,
	        page: 1,
	        pageSize: 10,
	        allList: 11, //默认比第一页数据多1
        	colorstyle:{},
        	listStyle: 'profit',
        	paramStyle: 1,
        	hasList: true,
        	isiOSX: false,
        	listHeight: {height: (document.body.clientHeight - 69 - 44) + 'px'}
	    };
	},
	created() {
		//this.$route.query.id//项目id
		this.isiOSX = this.isIphoneX();
		if(this.isiOSX) {
			this.listHeight.height = (document.body.clientHeight - 89 - 44) + 'px';
		}
		this.paramStyle = this.param.split(',')[0];
		if(this.param.split(',')[0] == 1) {
			this.colorstyle = {color: '#F56D2D'};
		}else if(this.param.split(',')[0] == 2) {
			this.colorstyle = {color: '#F16066'};
		}
		if(this.param.split(',')[1] == 1) {
			this.listStyle = 'profit';
		}else if(this.param.split(',')[1] == 2) {
			this.listStyle = 'loss';
		}
		this.getInfo();
	},
	methods: {
		onLoad() {
	      // 异步更新数据
	      setTimeout(() => {
	      	this.page ++;
	      	this.getInfo();
		      	
	        // 加载状态结束
	        this.isLoading = false;
	      }, 500);
	      console.log(this.page)
	    },
	    onRefresh() {
	    	this.page = 1;
			this.finished = false;
	    	this.list = [];
		    this.getInfo();
	    },
	    getInfo() {
	    	if(this.param.split(',')[0] == 1) {
	    		this.$api.post("/coin/member/appInvest/queryInvestCreditsList", {creditsId: this.$route.query.id, profitType: this.listStyle, pageNum: this.page}).then(res => {
		        this.allList = res.total;
		        if (res.list.length == 0) {
		        	this.hasList = false;
		        }
		        if(res.list.length > 0) {
		        	for(let i in res.list) {
		        		res.list[i].credits = this.tranform(res.list[i].credits);
			        	this.list.push(res.list[i]);
			        }
		        }
		        this.loading = false;
		        if (this.list.length >= this.allList) {// 数据全部加载完成
		          this.finished = true;
		        }
		        if(this.isLoading) {
		        	this.$toast('刷新成功');
	        		this.isLoading = false;
		        }
	        }).catch(err => {
	            this.hasList = false;
		        let keys = Object.keys(err);
		     	let key = keys[0];
		  		let message = err.message || err[key][0]
		  		if(message.slice(0, 10) == 'timeout of') {
		  			this.$toast('网络不给力，请稍候重试');
		  			this.timeout = true;
		  		}else {
		  			this.$toast(message);
		  		}
	        });
	    	}else if(this.param.split(',')[0] == 2){
	    		this.$api.post("/coin/member/appInvest/queryInvestCoinList", {coinId: this.$route.query.id, profitType: this.listStyle, pageNum: this.page}).then(res => {
			        this.allList = res.total;
			        if(res.total <= 0) {
			        	this.hasList = false;
			        }
			        if(res.list.length > 0) {
			        	for(let i in res.list) {
			        		res.list[i].coin = this.tranform(res.list[i].coin);
				        	this.list.push(res.list[i]);
				        }
			        }
			        this.loading = false;
			        if (this.list.length >= this.allList) {// 数据全部加载完成
			          this.finished = true;
			        }
			        if(this.isLoading) {
			        	this.$toast('刷新成功');
		        		this.isLoading = false;
			        }
		        }).catch(err => {
		            this.hasList = false;
			        let keys = Object.keys(err);
			     	let key = keys[0];
			  		let message = err.message || err[key][0]
			  		if(message.slice(0, 10) == 'timeout of') {
			  			this.$toast('网络不给力，请稍候重试');
			  			this.timeout = true;
			  		}else {
			  			this.$toast(message);
			  		}
		        });
	    	}
	  	},
	  	tranform(data) {
	  		if(data != null && data != 0) {
	  			data = Number(data).toFixed(4) + '';
	  			let arr = [data.split('.')[0], data.split('.')[1]];
	  			return arr;
		    }else {
		    	return [0, '0000']
		    }
	  	}
	}
};
</script>

<style scoped>
.details{
    padding-top: 8px;
    /*min-height: 100%;    */
	box-sizing: border-box;
}
.details .van-pull-refresh {
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling:touch;
}
.van-cell{
	padding: 0;
	margin-bottom: 1px;
}
.van-cell:not(:last-child)::after{
	border: none;
}
.details_{
    padding: 16px;
    background-color: #fff;
    margin-bottom: 1px;
    display: flex;
    justify-content: space-between;
}
.title_1{
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    color: #333333;
    margin-bottom: 4px;
}
.time_2{
	font-size:12px;
	font-weight:400;
	color:rgba(153,153,153,1);
	line-height:17px;
}
.details_right{
    line-height: 40px;
}
.details_right span{
    font-size: 24px;
}
.details_right .monts_{
    font-size: 16px;
}	
.emptyMsg {
	padding-top: 100px;
	text-align: center;
}
.emptyMsg img {
	width: 106px;
	display: inline-block;
}
.emptyMsg .tip {
	color: #CCCCCC;
	font-size: 14px;
	margin-top: 17px;
	height: 20px;
	line-height: 20px;
}
.loading{
	width: 100%;
	/*padding-top: 100px;*/
	text-align: center;
}
.loading img {
	width: 35%;
	margin-top: 50%;
}

</style>


